import React, { useEffect, useState } from "react";
import { RiAddLargeFill, RiSubtractFill } from "react-icons/ri";
import { GoSortDesc } from "react-icons/go";
import { GoSortAsc } from "react-icons/go";
import {
  removeLevel2PropertiesBynanoId,
  setLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useDispatch, useSelector } from "react-redux";
import { handleHeaderSort } from "./HeaderSort";
import { handleHeirarchy } from "./HandleHeirarchy";
import { getSheetControls } from "../../../features/reduxworkbook/WorkbookControllingSlice";

export default function TableHeader({
  tableHeader,
  sortArray,
  rowKeys,
  hierarchy,
  Sheetid,
  isColumnPresent,
  valueKeys,
  groupByKeys,
  isMeasureOnTop,
  vizType,
  bold,
  fontColor,
  bgColor,
}) {
  // console.log(rowKeys);

  const [hoveredHeader, setHoveredHeader] = useState(null);
  const [isNextItemFoundFor, setIsNextItemFoundFor] = useState([]);
  const dispatch = useDispatch();
  const dateHierarchy = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "dateHierarchy" })
  );
  const [hoveredCaption, setHoveredCaption] = useState(null);
  let foundedHierarchy;
  if (
    hoveredHeader !== null &&
    hoveredHeader.hierarchyItemDataType === "String"
  ) {
    foundedHierarchy = hierarchy.find((item) =>
      item.hierarchyArray.find(
        (arr) => arr.rename === hoveredHeader.hierarchyItem
      )
    );
  } else if (
    hoveredHeader !== null &&
    hoveredHeader.hierarchyItemDataType === "Date"
  ) {
    foundedHierarchy = hierarchy.find((item) =>
      item.hierarchyArray.find((arr) => {
        if (arr.dataType === hoveredHeader.hierarchyItemDataType) {
          // console.log(arr);
          return (
            `${arr.rename}${arr.dateFormat.value}` ===
            hoveredHeader.hierarchyItem
          );
        }
      })
    );
  } else {
    foundedHierarchy = undefined;
  }

  const handleHover = (headerItem) => {
    // console.log(headerItem.caption);
    setHoveredCaption(headerItem.caption);
    if (isMeasureOnTop) {
      const hierarchyTypeRow = rowKeys.find(
        (rItem) => rItem.responseKey === headerItem.hierarchyKey
      );
      // console.log();

      if (hierarchyTypeRow) {
        // console.log(headerItem);
        setHoveredHeader({
          hierarchyItem: hierarchyTypeRow.responseKey,
          hierarchyItemDataType: hierarchyTypeRow.dataType,
          hierarchyType: "row",
        });
      }
      const hierarchyTypeColumn = groupByKeys.find(
        (rItem) => rItem.responseKey === headerItem.hierarchyKey
      );
      // console.log();

      if (hierarchyTypeColumn) {
        // console.log(headerItem);
        // console.log(hierarchyTypeColumn);
        setHoveredHeader({
          hierarchyItem: hierarchyTypeColumn.responseKey,
          hierarchyItemDataType: hierarchyTypeColumn.dataType,
          hierarchyType: "column",
        });
      }
    } else {
      const hierarchyTypeRow = rowKeys.find(
        (rItem) => rItem.responseKey === headerItem.hierarchyKey
      );
      // console.log();

      if (hierarchyTypeRow) {
        // console.log(headerItem);
        setHoveredHeader({
          hierarchyItem: hierarchyTypeRow.responseKey,
          hierarchyItemDataType: hierarchyTypeRow.dataType,
          hierarchyType: vizType === "table" ? "column" : "row",
        });
      }
      const hierarchyTypeColumn = groupByKeys.find(
        (rItem) => rItem.responseKey === headerItem.hierarchyKey
      );
      // console.log();

      if (hierarchyTypeColumn) {
        // console.log(headerItem);
        // console.log(hierarchyTypeColumn);
        setHoveredHeader({
          hierarchyItem: hierarchyTypeColumn.responseKey,
          hierarchyItemDataType: hierarchyTypeColumn.dataType,
          hierarchyType: "column",
        });
      }
    }
  };

  useEffect(() => {
    if (foundedHierarchy) {
      const currentIndex = foundedHierarchy.hierarchyArray.findIndex((arr) => {
        if (arr.dataType === "String") {
          return arr.rename === hoveredHeader.hierarchyItem;
        } else {
          const combinedValue = `${arr.columnName}${arr.dateFormat.value}`;
          return combinedValue === hoveredHeader.hierarchyItem;
        }
      });

      if (
        currentIndex !== -1 &&
        currentIndex < foundedHierarchy.hierarchyArray.length - 1
      ) {
        const nextItem = foundedHierarchy.hierarchyArray[currentIndex + 1];

        const itemFound =
          hoveredHeader.hierarchyType === "column"
            ? groupByKeys.find((row) => {
                if (hoveredHeader.hierarchyItemDataType === "String") {
                  return row.caption === nextItem.rename;
                } else {
                  return (
                    row.responseKey ===
                    `${nextItem.columnName}${nextItem.dateFormat.value}`
                  );
                }
              })
            : rowKeys.find((row) => {
                if (hoveredHeader.hierarchyItemDataType === "String") {
                  return row.caption === nextItem.rename;
                } else {
                  return (
                    row.responseKey ===
                    `${nextItem.columnName}${nextItem.dateFormat.value}`
                  );
                }
              });
        // Update state only if needed to avoid unnecessary re-renders
        if (
          itemFound &&
          !isNextItemFoundFor.includes(hoveredHeader.hierarchyItem) &&
          hoveredHeader !== null
        ) {
          setIsNextItemFoundFor((prevState) => {
            return [...prevState, hoveredHeader.hierarchyItem];
          });
        } else if (
          !itemFound &&
          isNextItemFoundFor.includes(hoveredHeader.hierarchyItem)
        ) {
          setIsNextItemFoundFor((prevState) =>
            prevState.filter((item) => item !== hoveredHeader.hierarchyItem)
          );
        }
      }
    }
  }, [rowKeys, foundedHierarchy, hoveredHeader, isNextItemFoundFor]);

  const handleColumnClick = (headerItem) => {
    // console.log(headerItem.caption);
    handleHeaderSort(
      headerItem,
      isColumnPresent,
      sortArray,
      rowKeys,
      valueKeys,
      dispatch,
      Sheetid
    );
  };
  function whatIconShouldDisplay(hoveredHeader, headerItem) {
    // console.log(hoveredHeader);
    let requiredArray = hoveredHeader
      ? vizType === "simpleTable"
        ? hoveredHeader.hierarchyType === "column"
          ? groupByKeys
          : rowKeys
        : vizType === "table"
        ? rowKeys
        : []
      : [];

    if (headerItem?.icon === "plus") {
      return (
        <RiAddLargeFill
          className={`text-[12px] cursor-pointer transition-all duration-300 ease-in-out`}
          onClick={() =>
            handleHeirarchy({
              headerId: headerItem.nanoId,
              foundHierachy: foundedHierarchy,
              requiredArray: requiredArray,
              dispatch: dispatch,
              functionToAddAndUpdate: setLevel2Properties,
              functionToRemove: removeLevel2PropertiesBynanoId,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: null,
              headerDataType: hoveredHeader.hierarchyItemDataType,
              dateHierarchy,
              stringHirarchy: hierarchy,
              headerHierarchyType: hoveredHeader.hierarchyType,
            })
          }
        />
      );
    }
    if (headerItem?.icon === "minus") {
      return (
        <RiSubtractFill
          className={`text-[12px] cursor-pointer transition-all duration-300 ease-in-out`}
          onClick={() =>
            handleHeirarchy({
              headerId: headerItem.nanoId,
              foundHierachy: foundedHierarchy,
              requiredArray: requiredArray,
              dispatch: dispatch,
              functionToAddAndUpdate: setLevel2Properties,
              functionToRemove: removeLevel2PropertiesBynanoId,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: null,
              headerDataType: hoveredHeader.hierarchyItemDataType,
              dateHierarchy,
              stringHirarchy: hierarchy,
              headerHierarchyType: hoveredHeader.hierarchyType,
            })
          }
        />
      );
    }
  }

  return (
    <thead className={`sticky top-0`}>
      {tableHeader.map((headerRow, rowIndex) => (
        <tr key={rowIndex}>
          {headerRow.map((headerItem, columnIndex) => {
            const existingSort = sortArray.find(
              (sortItem) => sortItem.column === headerItem.columnId
            );
            const icon = whatIconShouldDisplay(hoveredHeader, headerItem);
            // console.log(existingSort);
            // console.log(headerItem);

            return (
              <th
                key={headerItem?.columnId}
                colSpan={headerItem?.columnSpan || 1}
                rowSpan={headerItem?.rowSpan || 1}
                onMouseEnter={() => {
                  headerItem !== undefined && handleHover(headerItem);
                }}
                onMouseLeave={() => {
                  setHoveredHeader(null);
                  setHoveredCaption(null);
                }}
                onClick={() => handleColumnClick(headerItem)}
                className={`w-auto cursor-pointer text-center text-[15px] outline outline-[0.8px] outline-gray-300 truncate px-2 ${
                  bold ? "font-semibold" : "font-normal"
                }`}
                style={{
                  backgroundColor: bgColor || "#e5e7eb",
                  color: fontColor || "#374151",
                }}
              >
                {hoveredCaption === headerItem.caption ? (
                  <button className="w-full items-center justify-center flex gap-1">
                    {headerItem?.displayValue
                      ? headerItem?.displayValue
                      : headerItem?.caption}
                    {icon ? (
                      <button onClick={(e) => e.stopPropagation()}>
                        {icon}
                      </button>
                    ) : null}

                    {existingSort ? (
                      existingSort.order === "ASC" ? (
                        <GoSortAsc
                          onClick={() => handleColumnClick(headerItem)}
                        />
                      ) : (
                        <GoSortDesc
                          onClick={() => handleColumnClick(headerItem)}
                        />
                      )
                    ) : null}
                  </button>
                ) : (
                  <button className="w-full items-center justify-center flex gap-1">
                    {headerItem?.displayValue
                      ? headerItem?.displayValue
                      : headerItem?.caption}
                    {existingSort ? (
                      existingSort.order === "ASC" ? (
                        <GoSortAsc />
                      ) : (
                        <GoSortDesc />
                      )
                    ) : null}
                  </button>
                )}
              </th>
            );
          })}
        </tr>
      ))}
    </thead>
  );
}
